import DeletedLogEdit from './DeletedLogEdit'

export default DeletedLogEdit;